// extracted by mini-css-extract-plugin
export default {"alert":"DashboardAlert_alert__odkt2","closebtn":"DashboardAlert_closebtn__2Lk1E"};